type BulkUpdateTracker = (
  taskId: string,
  options?: { message?: string; module?: string },
) => void;

let tracker: BulkUpdateTracker | null = null;

export const registerBulkUpdateTracker = (fn: BulkUpdateTracker | null) => {
  tracker = fn;
};

// Which grid the job touches, so only that one blocks. Taken from the request path
// because the module already identifies the endpoint — /workspace/module/company/...
// and /workspace/module-properties/company/... both mean company.
const moduleFromUrl = (url: string) => {
  const moduleMatch = url?.match(/\/workspace\/module(?:-properties)?\/([^/?]+)/);
  if (moduleMatch) return moduleMatch[1];
  if (url?.includes("/workspace/contacts/")) return "contact";
  // namespaced by the list it writes to rather than the module it writes from, so the
  // path names neither. This console only has Contacts, so it always maps to "contact".
  if (url?.includes("/workspace/add-to-marketing-list")) return "contact";
  // the list detail grid lives under /contacts/marketing, so blocking "contact" covers it
  if (url?.includes("/workspace/marketing/delete-contacts-marketing-list")) return "contact";
  return "";
};

// Bulk endpoints answer 202 with the celery task id; that pair is the only
// signal the UI needs to switch from "done" to "queued, watch it finish".
export const trackBulkUpdateResponse = (response: any) => {
  const taskId = response?.data?.task_id;
  if (response?.status === 202 && taskId && tracker) {
    tracker(taskId, {
      // bulk-delete answers under `msg`; every other bulk endpoint uses `message`
      message: response?.data?.message || response?.data?.msg,
      module: moduleFromUrl(response?.config?.url || ""),
    });
  }
  return response;
};

export const isBulkUpdateQueued = (response: any) =>
  Boolean(response?.status === 202 && response?.data?.task_id);
